import { Box, IconButton, Typography } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export default function AspectClearableLabel({
  icon,
  label,
  selectedValues,
  onClear,
  onClick,
}: {
  icon: React.ReactNode;
  label: React.ReactNode;
  selectedValues?: string[];
  onClear?: () => void;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}) {
  const hasSelections = selectedValues && selectedValues.length > 0;
  const labelValues = hasSelections ? selectedValues : [label];
  const hasSelectionLabel = hasSelections && label !== selectedValues?.[0];
  return (
    <Box
      sx={(theme) => ({
        maxWidth: "100%",
        display: "grid",
        gridTemplateColumns: "auto minmax(0, 1fr) auto auto",
        columnGap: 1,
        padding: theme.spacing(1),
        borderRadius: 5,
        "@media (hover: hover)": {
          "&:hover": {
            backgroundColor: "grey.100",
          },
        },
        cursor: "pointer",
        alignItems: hasSelections && hasSelectionLabel ? "start" : "center",
      })}
      onClick={onClick}
    >
      {hasSelectionLabel && (
        <Typography
          variant="caption"
          sx={{
            gridRow: "1",
            gridColumn: "2",
          }}
        >
          {label}
        </Typography>
      )}
      <Box
        sx={{
          gridRow: 2,
          gridColumn: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {icon}
      </Box>
      <Box
        sx={{
          gridRow: 2,
          gridColumn: 2,
        }}
      >
        {labelValues.map((selectedValue, index) => (
          <Typography
            key={index}
            className="main-label"
            sx={{
              fontWeight: hasSelections ? "bold" : "inherit",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {selectedValue}
          </Typography>
        ))}
      </Box>

      {hasSelections && (
        <IconButton
          sx={{
            gridRow: hasSelectionLabel ? "1 / span 2" : 2,
            gridColumn: 4,
            color: "black",
            alignSelf: "center",
            backgroundColor: "grey.100",
          }}
          size="small"
        >
          <ClearIcon
            onClick={(e) => {
              if (onClear) {
                e.stopPropagation();
                onClear();
              }
            }}
          />
        </IconButton>
      )}
    </Box>
  );
}
